




























































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';
import AmetrasInfoTooltipTemplate from '@/views/AmetrasInfoTooltipTemplate.vue';
import {DOCUMENT_SCROLL_SERVICE_INSTANCE} from '@/services/documentscroll.service';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import {DIALOG_STACK_INSTANCE, DialogInstance} from '@/utils/dialog.stack';


interface FilterRowType {
  range: boolean;
  searchValue: DisguiseDto.SearchValues;
}

interface TableHeader {
  text: string;
  value?: string;
  align?: 'start' | 'center' | 'end';
  sortable?: boolean;
  filterable?: boolean;
  divider?: boolean;
  class?: string | string[];
  width?: string | number;
  filter?: (value: any, search: string, item: any) => boolean;
  sort?: (a: any, b: any) => number;
}

export interface FieldConfiguration {
  uiType: DisguiseDto.EnumUiType;
  dataType: DisguiseDto.EnumDataType;
  length: number;
  min: number;
  max: number;
  selectValues: DisguiseDto.SelectDto[];
  defaultSelectValue: DisguiseDto.SelectDto;
  autofillName?: string;
  label: string;

  [data: string]: any;
}

@Component({
  components: {
    AmetrasInfoTooltipTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasSelectFieldTemplate,
    AmetrasTextFieldTemplate
  }
})
export default class AmetrasAdvancedFilterTemplate extends Vue implements DialogInstance {
  @Prop({
    type: Object as () => FieldConfiguration,
    required: true
  }) header!: FieldConfiguration;
  @Prop({
    type: Array as () => DisguiseDto.SearchValues[],
    required: true
  }) searchConfiguration!: DisguiseDto.SearchValues[];

  @Prop({
    required: false,
    default: false
  }) simpleMode!: boolean;

  filterRows: FilterRowType[] = [];

  hideLastDeleteButton: boolean = false;
  originalDocumentScrollXOffset: number = 0;

  headers: TableHeader[] = [
    {text: 'Range', sortable: false},
    {text: 'Enthält oder von-bis', sortable: false},
    {text: 'Ausschluss', sortable: false},
    {text: 'Löschen', sortable: false}
  ];

  simpleHeader: TableHeader[] = [
    {text: 'Entspricht', sortable: false},
    {text: 'Ausschluss', sortable: false},
    {text: 'Löschen', sortable: false}
  ];

  relationalOperatorHints: Map<DisguiseDto.EnumDTSearchValueOperator, {
    placeholder: string;
    hint: string;
  }> = new Map([
    ['EQUALS', { placeholder: 'Entspricht exakt', hint: 'Zeige Ergebnisse, die diesem Wert exakt entsprechen' }],
    ['LIKE', { placeholder: 'Enthält', hint: 'Zeige Ergebnisse, die diesen Wert enthalten' }],
    ['STARTS_WITH', { placeholder: 'Beginnt mit', hint: 'Zeige Ergebnisse, die mit diesem Wert beginnen' }],
    ['ENDS_WITH', { placeholder: 'Endet mit', hint: 'Zeige Ergebnisse, die mit diesem Wert enden' }],
    ['GREATER_THAN', { placeholder: 'Größer als', hint: 'Zeige Ergebnisse, die größer sind als der eingegebene Wert' }],
    ['GREATER_THAN_OR_EQUAL_TO', { placeholder: 'Größer/gleich als', hint: 'Zeige Ergebnisse, die größer oder gleich sind als der eingegebene Wert' }],
    ['LESS_THAN', { placeholder: 'Kleiner als', hint: 'Zeige Ergebnisse, die kleiner sind als der eingegebene Wert' }],
    ['LESS_THAN_OR_EQUAL_TO', { placeholder: 'Kleiner/gleich als', hint: 'Zeige Ergebnisse, die kleiner oder gleich sind als der eingegebene Wert' }],
  ]);

  relationalOperators: Array<{
    text: string,
    value: DisguiseDto.EnumDTSearchValueOperator
  }> = [{
    text: '=',
    value: 'EQUALS'
  }, {
    text: '>',
    value: 'GREATER_THAN'
  }, {
    text: '≥',
    value: 'GREATER_THAN_OR_EQUAL_TO'
  }, {
    text: '<',
    value: 'LESS_THAN'
  }, {
    text: '≤',
    value: 'LESS_THAN_OR_EQUAL_TO'
  }, {
    text: 'Beginnt mit',
    value: 'STARTS_WITH'
  }, {
    text: 'Endet mit',
    value: 'ENDS_WITH'
  }, {
    text: 'Enthält',
    value: 'LIKE'
  }];

  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;
  hideOverlay: boolean = false;

  rangeFilterChanged(filterRow: FilterRowType) {
    filterRow.range = !filterRow.range;
  }

  hideThisDeleteButton(filterIndex: number) {
    let hideThisButton = true;
    if (this.hideLastDeleteButton) {
      hideThisButton = this.filterRows.length !== filterIndex + 1;
    }
    return hideThisButton;
  }

  created() {
    DIALOG_STACK_INSTANCE.registerDialog(this);
    this.hideLastDeleteButton = !(this.searchConfiguration && this.searchConfiguration.length);
    this.searchConfigChanged(this.searchConfiguration);
    this.attachKeyListener();
  }

  mounted() {
    this.$nextTick(() => {
      // initial render phase
      this.$nextTick(() => {
        // ref update
        if (this.searchConfiguration && this.searchConfiguration.length) {
          this.focusAddButton();
        } else {
          this.focusRangeFilter();
        }
      });
      this.originalDocumentScrollXOffset =
          DOCUMENT_SCROLL_SERVICE_INSTANCE.readCurrentDocumentScrollXPosition();
      DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(0);
    });
  }

  @Watch('searchConfiguration', {
    deep: true
  }) searchConfigChanged(newValue: DisguiseDto.SearchValues[]) {
    const filterRows: FilterRowType[] = [];
    if (newValue && newValue.length) {
      for (const currentSearchConfigEntry of newValue) {
        if (currentSearchConfigEntry.equal !== undefined) {
          filterRows.push({
            range: false,
            searchValue: {...currentSearchConfigEntry}
          });
        } else if (currentSearchConfigEntry.min !== undefined || currentSearchConfigEntry.max !== undefined) {
          filterRows.push({
            range: true,
            searchValue: {...currentSearchConfigEntry}
          });
        }
      }
    } else {
      filterRows.push({
        range: false,
        searchValue: {
          negate: false,
          relationalOperator: 'EQUALS'
        }
      });
    }
    this.filterRows = filterRows;
  }

  addEmptyFilterRow() {
    this.filterRows.push({
      range: false,
      searchValue: {
        negate: false,
        relationalOperator: 'EQUALS'
      }
    });
    this.hideLastDeleteButton = true;

    this.$nextTick(() => {
      this.focusRangeFilter(true);
    });
  }

  commitChanges() {
    const result: DisguiseDto.SearchValues[] = [];
    for (const currentFilterRow of this.filterRows) {
      if (!currentFilterRow.range) {
        if (currentFilterRow.searchValue.equal !== undefined) {
          result.push({
            negate: currentFilterRow.searchValue.negate,
            equal: currentFilterRow.searchValue.equal,
            relationalOperator: currentFilterRow.searchValue.relationalOperator
          });
        }
      } else {
        if (currentFilterRow.searchValue.min !== undefined || currentFilterRow.searchValue.max !== undefined) {
          result.push({
            negate: currentFilterRow.searchValue.negate,
            min: currentFilterRow.searchValue.min,
            max: currentFilterRow.searchValue.max
          });
        }
      }
    }
    DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(this.originalDocumentScrollXOffset);
    this.$emit('change', result);
  }

  revertChanges() {
    if (document && document.scrollingElement) {
      DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(this.originalDocumentScrollXOffset);
    }
    this.$emit('abort');
  }

  destroyed() {
    this.detachKeyListener();
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
  }

  shouldHideOverlay(): void {
    this.hideOverlay = true;
  }

  shouldRestoreHideOverlay(): void {
    this.hideOverlay = false;
  }

  private detachKeyListener() {
    window.removeEventListener('keydown', this.keyPressed);
  }

  private attachKeyListener() {
    window.addEventListener('keydown', this.keyPressed);
  }

  private keyPressed(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.revertChanges();
    } else if (event.key === 'Enter') {
      this.commitChanges();
    }
  }

  private focusRangeFilter(last: boolean = false) {
    const lastRangeFilter = this.$refs['range-' + (last ? this.filterRows.length - 1 : 0)];
    if (lastRangeFilter) {
      const lastRangeFilterEl = (lastRangeFilter as Vue).$el;
      HTML_SERVICE_INSTANCE.focusFirstNode(lastRangeFilterEl);
    }
  }

  private focusAddButton() {
    const addButton = this.$refs['add-btn'];
    if (addButton) {
      const addButtonEl = (addButton as Vue).$el;
      if (addButtonEl instanceof HTMLElement) {
        addButtonEl.focus();
      }
    }
  }
}
